import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import TeamsoncallContainer from './TeamsoncallContainer'


const TeamsoncallRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><TeamsoncallContainer></TeamsoncallContainer></Provider>
}

TeamsoncallRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default TeamsoncallRoot
